const createReader = ({window, pocketUrl}) => {
  let popup = null;

  return {
    open() {
      popup = popup || window.open(`${pocketUrl}/a/`, 'pktbtn_queue');
      popup.focus();
      return this;
    }
  }
};

export {createReader};
